import moment from 'moment'

export function applyConstraints(panX, panY, scale, correctX, correctY,
    displayWidth, displayHeight, imageWidth, imageHeight, zoomPermitted) {
    correctX = correctX === undefined ? 0 : correctX
    correctY = correctY === undefined ? 0 : correctY

    // Calculate optimal scale
    const minScale = displayWidth / displayHeight > imageWidth / imageHeight
        ? displayHeight / imageHeight
        : displayWidth / imageWidth
    const maxScale = zoomPermitted ? 4.0 : minScale

    // Constrain zoom level
    if (scale <= minScale) {
        scale = minScale
    } else if (scale > maxScale) {
        scale = maxScale
    } else {
        panX -= correctX
        panY -= correctY
    }

    // Calculate pan constraints
    let minX, minY, maxX, maxY

    if (imageWidth * scale <= displayWidth) {
        minX = (displayWidth - imageWidth * scale) / 2 / scale
        maxX = minX
    } else {
        maxX = 0
        minX = (displayWidth - imageWidth * scale) / scale
    }

    if (imageHeight * scale <= displayHeight) {
        minY = (displayHeight - imageHeight * scale) / 2 / scale
        maxY = minY
    } else {
        maxY = 0
        minY = (displayHeight - imageHeight * scale) / scale
    }
    // Constrain panX
    if (panX < minX) {
        panX = minX
    } else if (panX > maxX) {
        panX = maxX
    }

    // Constrain panY
    if (panY < minY) {
        panY = minY
    } else if (panY > maxY) {
        panY = maxY
    }

    return {
        panX: panX,
        panY: panY,
        scale: scale,
        minScale: minScale,
        maxScale: maxScale,
        zoomed: ( scale / 1 ) > minScale,
        zoomedAllTheWayIn: scale > ( maxScale / 1.05 )
    }
}

// An image's time to the second, HH:mm:ss. date_unix is when the camera took
// it, by its own clock, stored as if UTC, as its time (HH:mm) is.
export function imageTimeWithSeconds(image) {
    return moment.unix(image.date_unix).utc().format('HH:mm:ss')
}

// How the URL and the selected time name each image of a day's list, in list
// order: HH:mm, as ever, for an image alone in its minute; HH:mm:ss when it
// shares the minute with another, so each can be chosen; its filename if it
// shares the second too.
export function imageTimeKeys(images) {
    const perMinute = {}
    const perSecond = {}
    const seconds = images.map(image => {
        const second = imageTimeWithSeconds(image)
        perMinute[image.time] = (perMinute[image.time] || 0) + 1
        perSecond[second] = (perSecond[second] || 0) + 1
        return second
    })
    return images.map((image, i) => {
        if (perMinute[image.time] < 2) {
            return image.time
        }
        return perSecond[seconds[i]] < 2 ? seconds[i] : image.image
    })
}

export function imageTimeKey(image, images) {
    return imageTimeKeys(images)[images.indexOf(image)]
}

// Where in images the image a time names is: a key from imageTimeKeys, a
// filename, or HH:mm for the first image of that minute, as older links have.
// False when none is.
export function findImagePosition(images, time) {
    if (!time) {
        return false
    }
    let pos = images.findIndex(image => image.image === time)
    if (pos === -1) {
        pos = /^\d\d:\d\d:\d\d$/.test(time)
            ? images.findIndex(image => imageTimeWithSeconds(image) === time)
            : images.findIndex(image => image.time === time)
    }
    return pos === -1 ? false : pos
}

export function getSelectedPositionFromList(camera, time) {
    return findImagePosition(camera.imageList.images, time)
}

export function getSelectedPositionFromListByFilename(camera, filename) {
  for (let pos=0; pos < camera.imageList.images.length; pos++) {
    const image = camera.imageList.images[pos];
    if (filename === image.image) {
      return pos;
    }
  }
  return false;
}

export function getPreviousDate(dates, selectedDate) {
    if (!dates || !("start" in dates) || !("missing" in dates)) {
        return false
    }
    do {
        selectedDate = moment(selectedDate, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD')
    } while (dates.missing.indexOf(selectedDate) !== -1)
    if (moment(selectedDate, 'YYYY-MM-DD') < moment(dates.start, 'YYYY-MM-DD')) {
        // Can't go later than end date
        return false
    } else {
        return selectedDate
    }
}

export function getNextDate(dates, selectedDate) {
    if (!dates || !("end" in dates) || !("missing" in dates)) {
        return false
    }
    do {
        selectedDate = moment(selectedDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
    } while (dates.missing.indexOf(selectedDate) !== -1)
    if (moment(selectedDate, 'YYYY-MM-DD') > moment(dates.end, 'YYYY-MM-DD')) {
        // Can't go later than end date
        return false
    } else {
        return selectedDate
    }
}
